var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * [CLAIMS_CONTEXT]
 * purpose: Allows the user to select the electrical cause of a fire damage using image-based radio buttons and saves the selected qualification
 * touches: declaration, qualification, fireDamage
 * invariants: The selected electrical cause is synchronized with the fire damage qualification state; the available choices come from the configured electrical cause constants
 * inputs: qualification state, fireElectricalCause, FIRE_ELECTRICAL_CAUSE_IMAGE_CHOICES, change step
 * outputs: Updates the fire qualification through updateQualification or updateAndSaveQualification; displays the selected answer summary and handles the validation step
 * see: @declaration/store/qualification, @declaration/constants/fireDamageConstants, @shared/types/api/claim
 */
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { UiButton, UiRadio } from '@claims-ia/design-system';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import { FIRE_ELECTRICAL_CAUSE_ANSWERS, FIRE_ELECTRICAL_CAUSE_IMAGE_CHOICES, } from '@declaration/constants/fireDamageConstants';
const claim = namespace('claim');
const qualification = namespace('qualification');
let FireElectricalCauseQuestion = class FireElectricalCauseQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.isSaving = false;
        this.typeOfDamages = '';
    }
    get fireElectricalCauseChoices() {
        return FIRE_ELECTRICAL_CAUSE_IMAGE_CHOICES;
    }
    get selectedValue() {
        if (this.qualification.fireElectricalCause) {
            return this.qualification.fireElectricalCause;
        }
        return null;
    }
    get panelTitle() {
        return this.$tc('claim.qualification.fire_cause_extern_origin.title');
    }
    get sidebarTitle() {
        const key = 'claim.qualification.fire_cause_extern_origin.sidebar_title';
        return this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    get answer() {
        if (this.qualification.fireElectricalCause === null)
            return null;
        return this.$tc(FIRE_ELECTRICAL_CAUSE_ANSWERS[this.qualification.fireElectricalCause]);
    }
    get validateText() {
        return this.$tc('claim.damage.fire_electrical_cause.button.next_step');
    }
    get fireElectricalCauseUiChoices() {
        return this.fireElectricalCauseChoices.map((choice) => ({
            value: choice.value,
            label: this.$tc(choice.tradKey),
            imageSrc: choice.image,
        }));
    }
    onTypeOfDamagesClick(fireElectricalCause) {
        this.updateFireDamageQualification({
            qualificationPayload: {
                fireElectricalCause: fireElectricalCause !== this.qualification.fireElectricalCause
                    ? fireElectricalCause
                    : null,
            },
        });
    }
    async validate() {
        await this.updateAndSaveFireDamageQualification({
            qualificationPayload: {
                fireElectricalCause: this.qualification.fireElectricalCause,
            },
            step: this.step,
        });
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], FireElectricalCauseQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    qualification.State('qualification')
], FireElectricalCauseQuestion.prototype, "qualification", void 0);
__decorate([
    qualification.Action('updateQualification')
], FireElectricalCauseQuestion.prototype, "updateFireDamageQualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], FireElectricalCauseQuestion.prototype, "updateAndSaveFireDamageQualification", void 0);
FireElectricalCauseQuestion = __decorate([
    Component({
        components: { QuestionPanel, UiRadio, UiButton },
        props: QuestionProps,
    })
], FireElectricalCauseQuestion);
export default FireElectricalCauseQuestion;
